(function () {
  if (window.__anivDD) { window.__anivDD.scan(); return; }
  window.__anivDD = { scan: scan };

  function init(root) {
    if (root.__aniv) clearInterval(root.__aniv);
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-aniv-card]'));
    var preview = root.getAttribute('data-preview') || 'auto';
    var drift = 0;
    var seed = parseInt(root.getAttribute('data-server-now'), 10);
    if (seed > 0) drift = seed * 1000 - Date.now();
    if (window.fetch) {
      fetch('/cart.js', { method: 'HEAD', cache: 'no-store' })
        .then(function (r) { var t = Date.parse(r.headers.get('Date')); if (!isNaN(t)) drift = t - Date.now(); })
        .catch(function () {});
    }

    var ini = parseInt(root.getAttribute('data-start'), 10) * 1000;
    var fim = parseInt(root.getAttribute('data-end'), 10) * 1000;
    var dayLen = parseInt(root.getAttribute('data-daylen'), 10) || 86399;
    var ciclo = parseInt(root.getAttribute('data-cycle'), 10) || 7;

    function posicaoAtual(now) {
      if (preview === 'live') return 1;
      if (preview === 'off') return 0;
      if (!ini || !fim || now < ini || now >= fim) return 0;
      var delta = Math.floor((now - ini) / 1000);
      if (delta % 86400 > dayLen) return 0;
      return (Math.floor(delta / 86400) % ciclo) + 1;
    }

    function render() {
      var pos = posicaoAtual(Date.now() + drift);
      root.setAttribute('data-state', pos ? 'live' : 'off');
      // Cards de produto esgotado nem chegam no HTML (o Liquid pula), entao
      // contar os que ficaram visiveis diz se o dia tem oferta de verdade.
      // Sem nenhum, a secao some em vez de virar uma faixa vazia.
      var mostrados = 0;
      cards.forEach(function (c) {
        var on = pos > 0 && parseInt(c.getAttribute('data-pos'), 10) === pos;
        if (on) mostrados++;
        if (c.hidden === on) c.hidden = !on;
      });
      var esconder = (!pos || mostrados === 0) && preview === 'auto';
      if (root.hidden !== esconder) root.hidden = esconder;
    }

    render();
    root.__aniv = setInterval(render, 30000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); });
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll('[data-aniv-root]'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-aniv-root]'); if (r) init(r);
  });
})();